// const STORAGE_KEY = 'viewed_products';

// function getViewedProducts() {
//   try {
//     return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
//   } catch {
//     return [];
//   }
// }

// class RecentlyViewedProductsElement extends HTMLElement {
//   connectedCallback() {
//     this.sectionId      = this.dataset.sectionId;
//     this.currentId      = this.dataset.currentProductId || null;
//     this.excludeCurrent = this.dataset.excludeCurrent === 'true';
//     this.maxProducts    = parseInt(this.dataset.maxProducts) || 4;

//     // console.log('[RV] ✅ Connected | sectionId:', this.sectionId, '| currentId:', this.currentId);
//     this.init();
//   }

//   init() {
//     // STEP 1: viewed_products localStorage se products lo
//     let products = getViewedProducts();
//     // console.log('[RV] STEP 1 - viewed_products:', products);

//     if (!products || products.length === 0) {
//       // console.warn('[RV] ❌ viewed_products empty');
//       this.showEmpty();
//       return;
//     }

//     // STEP 2: Current product exclude
//     if (this.excludeCurrent && this.currentId) {
//       products = products.filter(p => String(p.id) !== String(this.currentId));
//       // console.log('[RV] STEP 2 - After exclude current:', products.length);
//     }

//     // STEP 3: Limit
//     products = products.slice(0, this.maxProducts);
//     // console.log('[RV] STEP 3 - Final products to render:', products.length);

//     // STEP 4: Cards render karo
//     this.renderCards(products);
//   }

//   renderCards(products) {
//     // Skeleton remove karo
//     const skeleton = this.querySelector('.resource-list');
//     if (skeleton) skeleton.remove();

//     // CSS variables list ke liye
//     const columns = this.dataset.columns || 4;

//     const list = document.createElement('div');
//     list.className = 'resource-list resource-list--grid';
//     list.setAttribute('data-testid', 'resource-list-grid');

//     products.forEach(product => {
//       const item = document.createElement('div');
//       item.className = 'resource-list__item';
//       item.innerHTML = this.buildCardHTML(product);
//       list.appendChild(item);
//     });

//     const sectionDiv = this.querySelector('.section-resource-list');
//     if (sectionDiv) {
//       sectionDiv.appendChild(list);
//       // console.log('[RV] ✅ Cards render ho gaye:', products.length);
//     } else {
//       // console.error('[RV] ❌ .section-resource-list nahi mila');
//     }
//   }

//   buildCardHTML(product) {
//     const img = product.img
//       ? `https:${product.img}`
//       : '';

//     const hoverImg = product.hoverImage
//       ? `https:${product.hoverImage}`
//       : '';

//     const url = product.url || '#';
//     const title = product.title || '';
//     const price = product.price || '';
//     const vendor = product.vendor || '';

//     return `
//       <div class="product-card">
//         <a href="${url}" class="product-card__media-wrapper">
//           <div class="product-card__media">
//             <img
//               src="${img}"
//               ${hoverImg ? `data-hover-src="${hoverImg}"` : ''}
//               alt="${title}"
//               loading="lazy"
//               width="600"
//               height="600"
//               class="product-card__image"
//             >
//           </div>
//         </a>
//         <div class="product-card__info">
//         <div class="product_rv_info mm">
//         <a href="${url}" class="product-card__title">
//         <p>${title}</p>
//         </a>
//         <div class="product-card__price">
//         <span>${price}</span>
//         </div>
//         </div>
//         <div class="rv_details">
//         ${vendor ? `<p class="product-card__vendor">${vendor}</p>` : ''}
//         </div>
//         </div>
//       </div>
//     `;
//   }

//   showEmpty() {
//     const skeletons = this.querySelectorAll('.resource-list');
//     skeletons.forEach(s => s.remove());
//     // console.log('[RV] Empty state shown');
//   }
// }

// if (!customElements.get('recently-viewed-products')) {
//   customElements.define('recently-viewed-products', RecentlyViewedProductsElement);
//   // console.log('[RV] ✅ Registered');
// } else {
//   // console.warn('[RV] ⚠️ Already registered');
// }



// const STORAGE_KEY = 'viewed_products';

// function getViewedProducts() {
//   try {
//     return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
//   } catch {
//     return [];
//   }
// }

// class RecentlyViewedProductsElement extends HTMLElement {
//   connectedCallback() {
//     this.sectionId      = this.dataset.sectionId;
//     this.currentId      = this.dataset.currentProductId || null;
//     this.excludeCurrent = this.dataset.excludeCurrent === 'true';
//     this.maxProducts    = parseInt(this.dataset.maxProducts) || 4;

//     // console.log('[RV] ✅ Connected | sectionId:', this.sectionId, '| currentId:', this.currentId);
//     this.init();
//   }

//   init() {
//     // STEP 1: viewed_products localStorage se products lo
//     let products = getViewedProducts();
//     // console.log('[RV] STEP 1 - viewed_products:', products);

//     if (!products || products.length === 0) {
//       // console.warn('[RV] ❌ viewed_products empty');
//       this.showEmpty();
//       return;
//     }

//     // STEP 2: Current product exclude
//     if (this.excludeCurrent && this.currentId) {
//       products = products.filter(p => String(p.id) !== String(this.currentId));
//       // console.log('[RV] STEP 2 - After exclude current:', products.length);
//     }

//     // STEP 3: Limit
//     products = products.slice(0, this.maxProducts);
//     // console.log('[RV] STEP 3 - Final products to render:', products.length);

//     // STEP 4: Cards render karo
//     this.renderCards(products);
//   }

//   renderCards(products) {
//     // Skeleton remove karo
//     const skeleton = this.querySelector('.resource-list');
//     if (skeleton) skeleton.remove();

//     // CSS variables list ke liye
//     const columns = this.dataset.columns || 4;

//     const list = document.createElement('div');
//     list.className = 'resource-list resource-list--grid';
//     list.setAttribute('data-testid', 'resource-list-grid');

//     products.forEach(product => {
//       const item = document.createElement('div');
//       item.className = 'resource-list__item';
//       item.innerHTML = this.buildCardHTML(product);
//       list.appendChild(item);
//     });

//     const sectionDiv = this.querySelector('.section-resource-list');
//     if (sectionDiv) {
//       sectionDiv.appendChild(list);
//       // console.log('[RV] ✅ Cards render ho gaye:', products.length);
//     } else {
//       // console.error('[RV] ❌ .section-resource-list nahi mila');
//     }
//   }

//   // ===== HELPER: Shopify image_url "//cdn.shopify.com/..." deta hai =====
//   // usko https: laga do. Agar url pehle se absolute hai to chhed-chhad na karo
//   // (warna https:https:// ban jata hai)
//   toSrc(url) {
//     if (!url) return '';
//     return url.startsWith('//') ? `https:${url}` : url;
//   }

//   // ===== HELPER: title/color me quote ho to HTML attribute na toote =====
//   esc(str) {
//     return String(str || '')
//       .replace(/&/g, '&amp;')
//       .replace(/"/g, '&quot;')
//       .replace(/</g, '&lt;');
//   }

//   // ===== NAYA: pehle COLOR check karo, warna metafield BUBBLES use karo =====
//   buildSwatchesHTML(product) {
//     const MAX_SHOW = 5; // card pe max kitne bubbles dikhane hain

//     // ---- CASE 1: COLOR mojood hai -> sirf AIK circle, aur bas ----
// if (product.color) {
//   let colorImg = product.colorImage || '';
//   if (!colorImg) {
//     const colorImages = {
//       'agata': '//alhajastore.com/cdn/shop/files/agata_9824fef3-3d21-4721-8289-6e22bc009a9c.png?v=1725530421',
//       'alga': '//alhajastore.com/cdn/shop/files/Alga_Necklace.jpg?v=1772010601',
//       'aqua': '//alhajastore.com/cdn/shop/files/aqua.png?v=1733218543',
//       'blue': '//alhajastore.com/cdn/shop/files/aquamarineblue.png?v=1765384937',
//       'calima': '//alhajastore.com/cdn/shop/files/calima_2.jpg?v=1772010600',
//       'caramelo': '//alhajastore.com/cdn/shop/files/calima_2.jpg?v=1772010600',
//       'cinnamon': '//alhajastore.com/cdn/shop/files/Cinnamon.png?v=1740390264',
//       'garnet': '//alhajastore.com/cdn/shop/files/rubired.png?v=1765384936',
//       'green': '//alhajastore.com/cdn/shop/files/emeraldgreen.png?v=1765384811',
//       'lilac': '//alhajastore.com/cdn/shop/files/Lilac.png?v=1740390264',
//       'persia green': '//alhajastore.com/cdn/shop/files/Persia_Green_Ring.jpg?v=1772010601',
//       'persia rose': '//alhajastore.com/cdn/shop/files/Persia_Rose_Ring.jpg?v=1772010601',
//       'pistachio': '//alhajastore.com/cdn/shop/files/pistachio.png?v=1736434245',
//       'rose': '//alhajastore.com/cdn/shop/files/rose.png?v=1733218102',
//       'silver': '//alhajastore.com/cdn/shop/files/PLATA.png?v=1721201351',
//       'plata': '//alhajastore.com/cdn/shop/files/PLATA.png?v=1721201351',
//       'oro': '//alhajastore.com/cdn/shop/files/ORO.png?v=1721201376'
//     };
//     const colorName = String(product.color).trim().toLowerCase();

//     colorImg = colorImages[colorName] || '';
//   }

//   const bg = product.colorSwatch || '#e3e3e3';

//   return `
//     <div class="rv-swatches rv-swatches--single">
//       <span
//         class="rv-swatch is-active"
//         style="--rv-swatch:${this.esc(bg)}"
//         title="${this.esc(product.color)}"
//       >
//         ${
//           colorImg
//             ? `<img
//                 class="rv-swatch__img"
//                 src="${this.toSrc(colorImg)}"
//                 alt="${this.esc(product.color)}"
//                 loading="lazy"
//               >`
//             : ''
//         }
//       </span>
//     </div>
//   `;
// }


//     // ---- CASE 2: COLOR nahi hai -> metafield ke bubbles use karo ----
//     const bubbles = Array.isArray(product.bubbles) ? product.bubbles : [];
//     if (bubbles.length === 0) return ''; // dono nahi to kuch mat dikhao

//     const shown = bubbles.slice(0, MAX_SHOW);
//     const extra = bubbles.length - shown.length;

//     return `
//       <div class="rv-swatches bubbles">
//         ${shown.map(b => `
//           <a href="${b.url}" class="rv-swatch ${b.current ? 'is-active' : ''}" title="${this.esc(b.title)}">
//             ${b.img ? `<img class="rv-swatch__img" src="${this.toSrc(b.img)}" alt="${this.esc(b.title)}" loading="lazy">` : ''}
//           </a>
//         `).join('')}
//       </div>
//     `;
//   }

//   buildCardHTML(product) {
//     const img      = this.toSrc(product.img);
//     const hoverImg = this.toSrc(product.hoverImage);

//     const url    = product.url || '#';
//     const title  = product.title || '';
//     const price  = product.price || '';
//     const vendor = product.vendor || '';

//     return `
//       <div class="product-card">
//         <a href="${url}" class="product-card__media-wrapper">
//           <div class="product-card__media">
//             <img
//               src="${img}"
//               ${hoverImg ? `data-hover-src="${hoverImg}"` : ''}
//               alt="${this.esc(title)}"
//               loading="lazy"
//               width="600"
//               height="600"
//               class="product-card__image"
//             >
//           </div>
//         </a>
//         <div class="product-card__info">
//         <div class="product_rv_info mm">
//         <a href="${url}" class="product-card__title">
//         <p>${title}</p>
//         </a>
//         <div class="product-card__price">
//         <span>${price}</span>
//         </div>
//         </div>
//         <div class="rv_details">
//         ${this.buildSwatchesHTML(product)}
//         ${vendor ? `<p class="product-card__vendor">${vendor}</p>` : ''}
//         </div>
//         </div>
//       </div>
//     `;
//   }

//   showEmpty() {
//     const skeletons = this.querySelectorAll('.resource-list');
//     skeletons.forEach(s => s.remove());
//     // console.log('[RV] Empty state shown');
//   }
// }

// if (!customElements.get('recently-viewed-products')) {
//   customElements.define('recently-viewed-products', RecentlyViewedProductsElement);
//   // console.log('[RV] ✅ Registered');
// } else {
//   // console.warn('[RV] ⚠️ Already registered');
// }



const STORAGE_KEY = 'viewed_products';

function getViewedProducts() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

class RecentlyViewedProductsElement extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.currentId = this.dataset.currentProductId || null;
    this.excludeCurrent = this.dataset.excludeCurrent === 'true';
    this.maxProducts = parseInt(this.dataset.maxProducts) || 4;
    this.init();
  }

  init() {
    let products = getViewedProducts();

    if (!products || products.length === 0) {
      this.showEmpty();
      return;
    }

    if (this.excludeCurrent && this.currentId) {
      products = products.filter(p => String(p.id) !== String(this.currentId));
    }

    products = products.slice(0, this.maxProducts);

    this.renderCards(products);
  }

  renderCards(products) {
    const skeleton = this.querySelector('.resource-list');
    if (skeleton) skeleton.remove();

    const columns = this.dataset.columns || 4;

    const list = document.createElement('div');
    list.className = 'resource-list resource-list--grid';
    list.setAttribute('data-testid', 'resource-list-grid');

    products.forEach(product => {
      const item = document.createElement('div');
      item.className = 'resource-list__item';
      item.innerHTML = this.buildCardHTML(product);
      list.appendChild(item);
    });

    const sectionDiv = this.querySelector('.section-resource-list');
    if (sectionDiv) {
      sectionDiv.appendChild(list);
    }
  }

  toSrc(url) {
    if (!url) return '';
    return url.startsWith('//') ? `https:${url}` : url;
  }

  esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  getMappedImage(name) {
    const colorImages = {
      'agata': '//alhajastore.com/cdn/shop/files/agata_9824fef3-3d21-4721-8289-6e22bc009a9c.png?v=1725530421',
      'alga': '//alhajastore.com/cdn/shop/files/Alga_Necklace.jpg?v=1772010601',
      'aqua': '//alhajastore.com/cdn/shop/files/aqua.png?v=1733218543',
      'blue': '//alhajastore.com/cdn/shop/files/aquamarineblue.png?v=1765384937',
      'calima': '//alhajastore.com/cdn/shop/files/calima_2.jpg?v=1772010600',
      'caramelo': '//alhajastore.com/cdn/shop/files/calima_2.jpg?v=1772010600',
      'cinnamon': '//alhajastore.com/cdn/shop/files/Cinnamon.png?v=1740390264',
      'garnet': '//alhajastore.com/cdn/shop/files/rubired.png?v=1765384936',
      'green': '//alhajastore.com/cdn/shop/files/emeraldgreen.png?v=1765384811',
      'lilac': '//alhajastore.com/cdn/shop/files/Lilac.png?v=1740390264',
      'persia green': '//alhajastore.com/cdn/shop/files/Persia_Green_Ring.jpg?v=1772010601',
      'persia rose': '//alhajastore.com/cdn/shop/files/Persia_Rose_Ring.jpg?v=1772010601',
      'pistachio': '//alhajastore.com/cdn/shop/files/pistachio.png?v=1736434245',
      'rose': '//alhajastore.com/cdn/shop/files/rose.png?v=1733218102',
      'silver': '//alhajastore.com/cdn/shop/files/PLATA.png?v=1721201351',
      'plata': '//alhajastore.com/cdn/shop/files/PLATA.png?v=1721201351',
      'oro': '//alhajastore.com/cdn/shop/files/ORO.png?v=1721201376'
    };
    const key = String(name || '').trim().toLowerCase();
    return colorImages[key] || '';
  }

  buildSwatchesHTML(product) {
    const MAX_SHOW = 5;

    if (product.swatchSource === 'group') {
      const groupColors = Array.isArray(product.groupColors) ? product.groupColors : [];

      const currentEntry = {
        id: product.id,
        title: product.color || product.title || '',
        url: product.url || '',
        img: this.getMappedImage(product.color) || product.img || '',
        current: true
      };

      const others = groupColors
        .filter(g => String(g.id) !== String(product.id))
        .map(g => ({
          ...g,
          img: this.getMappedImage(g.color || g.title) || g.img || ''
        }));

      const combined = [currentEntry, ...others];

      if (combined.length > 0) {
        const shown = combined.slice(0, MAX_SHOW);

        return `
          <div class="rv-swatches rv-swatches--group">
            ${shown.map(g => `
              <a href="${g.url}" class="rv-swatch ${g.current ? 'is-active' : ''}" title="${this.esc(g.title)}">
                ${g.img ? `<img class="rv-swatch__img" src="${this.toSrc(g.img)}" alt="${this.esc(g.title)}" loading="lazy">` : ''}
              </a>
            `).join('')}
          </div>
        `;
      }
    }

    if (product.color) {
      const colorImg = this.getMappedImage(product.color) || product.img || '';
      const bg = product.colorSwatch || '#e3e3e3';

      return `
        <div class="rv-swatches rv-swatches--single">
          <span
            class="rv-swatch is-active"
            style="--rv-swatch:${this.esc(bg)}"
            title="${this.esc(product.color)}"
          >
            ${
              colorImg
                ? `<img
                    class="rv-swatch__img"
                    src="${this.toSrc(colorImg)}"
                    alt="${this.esc(product.color)}"
                    loading="lazy"
                  >`
                : ''
            }
          </span>
        </div>
      `;
    }

    const bubbles = Array.isArray(product.bubbles) ? product.bubbles : [];
    if (bubbles.length === 0) return '';

    const shown = bubbles.slice(0, MAX_SHOW);

    return `
      <div class="rv-swatches bubbles">
        ${shown.map(b => `
          <a href="${b.url}" class="rv-swatch ${b.current ? 'is-active' : ''}" title="${this.esc(b.title)}">
            ${b.img ? `<img class="rv-swatch__img" src="${this.toSrc(b.img)}" alt="${this.esc(b.title)}" loading="lazy">` : ''}
          </a>
        `).join('')}
      </div>
    `;
  }

  buildCardHTML(product) {
    const img = this.toSrc(product.img);
    const hoverImg = this.toSrc(product.hoverImage);

    const url = product.url || '#';
    const title = product.title || '';
    const price = product.price || '';
    const vendor = product.vendor || '';

    return `
      <div class="product-card">
        <a href="${url}" class="product-card__media-wrapper">
          <div class="product-card__media">
            <img
              src="${img}"
              ${hoverImg ? `data-hover-src="${hoverImg}"` : ''}
              alt="${this.esc(title)}"
              loading="lazy"
              width="600"
              height="600"
              class="product-card__image"
            >
          </div>
        </a>
        <div class="product-card__info">
        <div class="product_rv_info mm">
        <a href="${url}" class="product-card__title">
        <p>${title}</p>
        </a>
        <div class="product-card__price">
        <span>${price}</span>
        </div>
        </div>
        <div class="rv_details">
        ${this.buildSwatchesHTML(product)}
        ${vendor ? `<p class="product-card__vendor">${vendor}</p>` : ''}
        </div>
        </div>
      </div>
    `;
  }

  showEmpty() {
    const skeletons = this.querySelectorAll('.resource-list');
    skeletons.forEach(s => s.remove());
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProductsElement);
}